export var STRIPE_ONBOARDING_RETURN_SEARCH_PARAM = 'stripe-onboarding-return';
